import styled from "styled-components";

export const Wrapper = styled.div`
  display: flex;
  align-items: top;
  justify-content: center;
  width: 26%;
  height: 100%;
  padding-top: 40px;
  font-size: 10px;
  box-sizing: border-box;
  @media (max-width: 1080px) {
    width: 35%;
  }
  @media (max-width: 720px) {
    margin-right: auto;
    width: 75%;
    padding-top: 0px;
  }
`;
